import React from 'react';
import PropTypes from 'prop-types';

// Utils
import getWindow from 'Utils/get-window';

// Components
import WaitFor from 'ComponentLibrary/utility/wait-for';

import connector from 'Utils/connector';
import connectFeatureFlags from 'Webapp/shared/app/connectors/connectFeatureFlags';

const getConsentData = () => {
  let tcData = null;

  try {
    const api = getWindow().__tcfapi;
    if (api) {
      api('getTCData', 2, (data, success) => {
        if (success) {
          tcData = data;
        }
      });
    }
  } catch (e) {
    return null;
  }

  return tcData;
};

// TCF 2.2 removed getTCData, so Google's CMP only answers ping; Sourcepoint
// still answers both. ping responds synchronously by spec.
const getPingData = () => {
  let pingData = null;

  try {
    getWindow().__tcfapi?.('ping', 2, (data) => {
      pingData = data;
    });
  } catch (e) {
    return null;
  }

  return pingData;
};

function gdprAppliesValue(googleCmp) {
  if (googleCmp) {
    const pingData = getPingData();
    return pingData && pingData.cmpStatus === 'loaded'
      ? pingData.gdprApplies
      : null;
  }
  const consentData = getConsentData();
  return consentData && consentData.gdprApplies;
}

function waitFor(googleCmp) {
  const value = gdprAppliesValue(googleCmp);
  if (googleCmp) {
    return typeof value !== 'undefined' && value !== null;
  }
  return (
    typeof value !== 'undefined' &&
    value !== null &&
    !!getWindow()._sp_?.gdpr?.loadPrivacyManagerModal
  );
}

function gdprApplies(googleCmp) {
  const gdprApplies = gdprAppliesValue(googleCmp);
  return gdprApplies && gdprApplies !== 'false';
}

class GdprApplies extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      gdprApplies: false,
    };
  }

  render() {
    const { FORCE_GDPR_APPLIES, GOOGLE_CMP } = this.props.featureFlags;
    return (
      <React.Fragment>
        <WaitFor
          predicate={() => FORCE_GDPR_APPLIES === true || waitFor(GOOGLE_CMP)}
          onWaitComplete={() =>
            this.setState({
              gdprApplies:
                FORCE_GDPR_APPLIES === true ? true : gdprApplies(GOOGLE_CMP),
            })
          }
        />
        {typeof this.props.children === 'function'
          ? this.props.children(this.state.gdprApplies)
          : null}
        {typeof this.props.children !== 'function' && this.state.gdprApplies
          ? this.props.children
          : null}
      </React.Fragment>
    );
  }
}

GdprApplies.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  featureFlags: PropTypes.shape({
    FORCE_GDPR_APPLIES: PropTypes.bool.isRequired,
    GOOGLE_CMP: PropTypes.bool,
  }).isRequired,
};

export default connector(connectFeatureFlags)(GdprApplies);
